<template>
  <div class="wrapper" @click="onPosterClick">
    <img
      class="poster"
      :src="posterSrc"
      alt="CAF Design"
    />
  </div>
  <Docker :currentIndex="2" />
  <img
    v-if="showBackImg"
    :src="require('@/assets/back_arrow.png')"
    class="back__img"
    @click.stop="onBackClick"
  />
</template>

<script>
import { ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import Docker from "@/components/Docker";

export default {
  name: "Scheme",
  components: { Docker },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const { locale } = useI18n();
    const { from } = route.query;

    const showBackImg = ref(from === "web");

    const posterSrc = computed(() => {
      const map = {
        "zh-TW": require("@/assets/cafdesign_tw.png"),
        "en-US": require("@/assets/cafdesign_en.png"),
        "zh-CN": require("@/assets/cafdesign_zh.png"),
        "ms-MY": require("@/assets/cafdesign_malay.png"),
      };
      return map[locale.value] || map["zh-CN"];
    });

    const onPosterClick = () => {
      window.open("https://www.cafdesign.com/", "_blank");
    };

    const onBackClick = () => {
      router.back();
    };

    return {
      showBackImg,
      posterSrc,
      onPosterClick,
      onBackClick,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/mixins.scss";
@import "@/style/viriables.scss";

.wrapper {
  @include fix-content-scrolly;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: $darkBgColor;
}

.poster {
  width: 100%;
  height: auto;
  display: block;
}

.back__img {
  position: absolute;
  top: 1%;
  left: 3%;
  width: 0.3rem;
  height: 0.3rem;
  z-index: 10;
}
</style>